import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService, NbSearchService, NbToastrService, NbTreeGridDataSource, NbTreeGridDataSourceBuilder } from '@nebular/theme';
import { EnvService } from 'src/app/env.service';
import { DashService } from '../dash.service';
import { AgGridAngular } from 'ag-grid-angular';
import { CellClickedEvent, ColDef, GridReadyEvent } from 'ag-grid-community';
import { read, utils, writeFile } from 'xlsx';
import * as moment from 'moment';

interface TreeNode<T> {
  data: T;
  children?: TreeNode<T>[];
  expanded?: boolean;
}

interface Rating {
  featureName:String;
  ratings:[any]
}


@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.css']
})
export class RatingComponent implements OnInit {

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  customColumn = 'Feature Name';
  defaultColumns = [ 'Customer Name', 'Email/Phone', 'Rating','Likes','Dislike' ];
  allColumns = [ this.customColumn, ...this.defaultColumns ];

  exporting = false;
  dataSource: NbTreeGridDataSource<Rating>;
  data = {};
  ratings = [];
  features = [];
  averageRating = 0;
  domLayout = 'autoHeight';
  public columnDefs: ColDef[] = [
    { field: 'date',resizable:true},
    { field: 'customerName',resizable:true},
    { field: 'customerContact',resizable:true},
    { field: 'rating' ,resizable:true},
    {field:'feedback.likes',headerName:'Liked Most',wrapText: true,autoHeight: true,resizable:true},
    {field:'feedback.dislike',headerName:"Could be Better",resizable:true,wrapText: true,autoHeight: true}
  ];
 
  // DefaultColDef sets props common to all Columns
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
  };

  constructor(private route: ActivatedRoute, public dialog: MatDialog, private router: Router, private http: HttpClient, private env: EnvService, public dashService: DashService, private searchService: NbSearchService, private toastrService: NbToastrService, private nbMenuService: NbMenuService,
    private dataSourceBuilder: NbTreeGridDataSourceBuilder<Rating>) { }
  ngOnInit(): void {

    this.getRatings();
  }

  getRatings = ()=>{
    this.http.get(this.env.apiUrl + "/api/ratings")
          .subscribe(response => {
              let rates = response["ratings"];
              let data = {}
              for(var i=0;i<rates.length;i++){
                var rate = rates[i];
                rate["date"] = rate.createdAt == undefined ? "" : moment(rate.createdAt).format("lll")
                rate.feedback = JSON.parse(rate.feedback);
                if(data[rate.featureName] != undefined){
                  data[rate.featureName].push(rate);
                }else {
                  data[rate.featureName] = [rate];
                }
              }
              //console.log(data);
              this.data = data;
              this.features = Object.keys(data);
              this.ratings = data[this.features[0]];
              this.ratings = this.sortRatings();
              this.calculateAverage();
          }, err => {
    });
      
    
  }

  calculateAverage() {
    var total = 0;
    this.ratings.forEach(rate=>{
      total += rate.rating;
    })
    this.averageRating = (total / this.ratings.length);
  }

  onTabChange(ev){
    this.ratings = this.data[ev.tabTitle];
    this.ratings = this.sortRatings()
    this.calculateAverage();
    console.log(this.ratings);
    
  }

  sortRatings(){
    return this.ratings.sort((r1,r2)=>{
      return r1.createdAt == undefined ? -1 : r2.createdAt == undefined ? -1 : r1.createdAt < r2.createdAt ? 1 : -1
    })
  }

  onGridReady(params: GridReadyEvent) {
    //params.columnApi.autoSizeColumns(['feedback.dislike']);
  }
 
  // Example of consuming Grid Event
  onCellClicked( e: CellClickedEvent): void {
    console.log('cellClicked', e);
  }
 
  // Example using Grid's API
  clearSelection(): void {
    
  }

  exportRatings(){
    if(this.ratings.length < 0){
      return;
    }
    this.exporting = true;
    let finalRatings = this.ratings.map(rating=>{
      let components = rating.customerContact.split("/");
      if(components.length > 0){
        return {
          "Customer Name":rating.customerName,
          "Customer Email":components[0],
          "Customer Mobile":components[1],
          "Rating":rating.rating,
          "Liked Most":(rating.feedback.likes ?? []).join(","),
          "What Could Be Better":rating.feedback.dislike ?? "",
          Date:moment(rating.createdAt).format("lll")
        }
      }else {
        return {

        }
      }
    })
    const ws = utils.json_to_sheet(finalRatings);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Ratings Data");
    writeFile(wb, this.ratings[0].featureName.toLowerCase() + "_ratings_data.xlsx");
    this.exporting = false;
  }

}
